const options = {
    threshold: 0.35
}

function fadeInSections (entries, observer) {
    entries.forEach(async  entry => {
        if (entry.isIntersecting) {
            let que = [...entry.target.querySelectorAll('[data-appear]')];
            que.sort((a, b) => +a.getAttribute('data-appear') - +b.getAttribute('data-appear'));

            for (const el of que) {
                await showItem(el);
            }

            if (entry.target.classList.contains('tutorial')) {
                let tutorialImages = document.querySelector('.tutorial__images');
                await showItem(tutorialImages);
                await showTutorialSteps();
            }

            if (entry.target.classList.contains('automatic')) {
                let round = document.querySelector('.automatic__round');
                let pics = document.querySelectorAll('.round-moving-pic');
                await moveInCircle(round, pics);
            }

            observer.unobserve(entry.target);
        }
    })
}

const scrollObserver = new IntersectionObserver(fadeInSections, options)

const sections = document.querySelectorAll('.fade-in-section');

sections.forEach(section => {
    scrollObserver.observe(section);
})

async function showTutorialSteps() {
    return new Promise(async function (resolve) {
        let steps = document.querySelectorAll('.tutorial__step');
        for (const step of steps) {
            await showItem(step, 300)
        }
        resolve()
    })
}

function showItem (item, delay = 400) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            item.classList.add('showed');
            resolve()
        }, delay)
    })
}

async function moveInCircle(parent, elements) {
    const params = {
        radius: parent.clientWidth / 2,
        elSize: elements[0].clientWidth,
        speed: 15,
    }

    let fullPath = {
        start: degToRad(180),
        end: degToRad(360),
    }

    let visibleArea = {
        start: degToRad(270),
        end: degToRad(360)
    }

    let between = (visibleArea.end - visibleArea.start) / (elements.length - 1);
    let i = 0;
    for (const el of elements) {
        let currentPath = {
            ...fullPath,
            end: fullPath.end - between * i,
        }
        await move(el, params, currentPath, visibleArea);
        i++
    }
}

function move(el, params, {start, end}, visibleArea) {
    let increment = 2 * Math.PI / 180;
    let distance = params.radius - params.elSize / 2;
    let current = start;
    return new Promise(function (resolve) {
        let moveInt = setInterval(function () {
            current += increment;

            let posInPX = {
                left: distance + params.radius * Math.sin(current),
                top: distance + params.radius * Math.cos(current),
            }

            let pos = {
                left: posInPX.left / (params.radius * 2) * 100,
                top: posInPX.top / (params.radius * 2) * 100
            }

            el.style.left = pos.left + '%';
            el.style.top = pos.top + '%';
            el.style.transform = `scale(${1 - (current - visibleArea.start)/4})`
            if (current >= end - ((end-start) / 2)) {
                resolve()
            }
            if (current > end) {
                clearInterval(moveInt)
            }
        }, params.speed);
    })
}

function degToRad(deg) {
    return (deg * Math.PI) / 180
}
